import { EditOutlined } from '@ant-design/icons';
import { Button as BaseButton } from 'antd';
import { observer } from 'mobx-react';
import React, { useState } from 'react';
import styled from 'styled-components';

import store from 'stores/RootStore';

import EditDocumentModal from './EditDocumentModal';

const Button = styled(BaseButton)`
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 5px;
`;

const EditIcon = styled(EditOutlined)`
  font-size: 20px;
`;

function EditDocumentButton() {
  const document = store.current;

  const [isModalVisible, setIsModalVisible] = useState(false);
  return (
    <>
      <Button onClick={() => setIsModalVisible(true)}>
        <EditIcon />
      </Button>

      {document && (
        <EditDocumentModal
          open={isModalVisible}
          onClose={() => setIsModalVisible(false)}
          document={document}
        />
      )}
    </>
  );
}

export default observer(EditDocumentButton);
